import classNames from 'classnames'
import { joinStringWithDashes } from '@helpers/utils'
import styles from './styles.module.scss'

type BulletProps = {
  unknown?: boolean
  disabled?: boolean
  isSelected?: boolean
  classes?: string
  changeValue: (arg: Record<string, string>) => void
  label: string
  value: string
  id: string
  variant?: 'round' | 'square'
}

function Bullet({
  value,
  id,
  changeValue,
  unknown = false,
  label,
  classes = '',
  disabled = false,
  isSelected = false,
  variant = 'round'
}: BulletProps) {
  const toggled = () => changeValue({ [id]: value })
  const bulletClassNames = classNames(
    styles.button__item,
    {
      [styles.active]: isSelected,
      [styles.unknown]: unknown
    },
    styles[variant],
    classes
  )
  return (
    <button
      className={bulletClassNames}
      disabled={disabled}
      type="button"
      onClick={toggled}
      value={label}
      id={`${joinStringWithDashes(id)}-${joinStringWithDashes(value)}`}
    >
      <span className={styles.radio__box}>{label}</span>
    </button>
  )
}
export default Bullet
